/* product-plan.js — draws this product's plan and names the days.

   The count comes from Liquid, which computed it from the same theme setting
   the cart reads. Only the DATES are computed here, by the shared clock, so
   the page and the checkout can never quote different arithmetic. */
(function () {
  'use strict';
  function boot() {
    var clock = window.LaybyClock;
    if (!clock) return;
    document.querySelectorAll('[data-product-plan]').forEach(function (root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var n = parseInt(root.dataset.payments, 10) || 1;
      var data = clock.readPlan(document) || {};
      var ship = clock.parseShipWindow(data.ship_window);
      var first = clock.nextPayday(clock.today());
      var last = clock.addDays(first, (n - 1) * 7);
      var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

      var h = root.querySelector('[data-plan-heading]');
      if (h) h.textContent = n + ' ' + DAYS[first.getDay()] + 's.';

      var d = root.querySelector('[data-plan-dates]');
      if (d) {
        d.innerHTML = 'First payment <b>' + clock.fmtLong(first) + '</b>, last one <b>' +
          clock.fmtLong(last) + '</b>. Then it ships free.';
      }

      var road = root.querySelector('[data-road]');
      if (road && window.LaybyRoad) {
        window.LaybyRoad.register(road, function () { return { payments: n }; });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
